import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import FormData from 'form-data';
import * as API from '../../api/routes';
import { currentUser } from '../../constants/defaultValues';
import { setCurrentUser } from '../../helpers/Utils';
import {
  SIGN_IN_WITH_EMAIL,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../actions';

import {
  signInWithEmailSuccessed,
  signInWithEmailFailed,
  forgotPasswordSuccessed,
  forgotPasswordFailed,
  resetPasswordSuccessed,
  resetPasswordFailed,
} from './actions';

function* signInWithEmail({ payload, callback }) {
  const { params } = payload;
  try {
    const body = new FormData();
    body.append('username', params.email);
    body.append('password', params.password);

    const loginUser = yield call(API.authLogin, body);

    if (loginUser.AccessToken) {
      const item = {
        AccessToken: loginUser.AccessToken,
        RefreshToken: loginUser.RefreshToken,
        Role: loginUser.permissions,
        Username: params.email,
        ...currentUser,
      };

      setCurrentUser(item);
      yield put(signInWithEmailSuccessed(item));
      yield call(callback?.bind());
    } else {
      yield put(signInWithEmailFailed(loginUser.message));
    }
  } catch (error) {
    yield put(signInWithEmailFailed(error.message));
  }
}

function* forgotPassword({ payload, callback }) {
  const { params } = payload;
  let data = new FormData();
  data.append('email', params.email);
  
  try {
    const res = yield call(API.forgotPassword, data);
    yield put(forgotPasswordSuccessed(res));
    yield call(callback?.bind());
  } catch(error) {
    yield put(forgotPasswordFailed(error.message));
  }
}

function* resetPassword({ payload, callback }) {
  const { params } = payload;
  let data = new FormData();
  data.append('email', params.email);
  data.append('code', params.code);
  data.append('password', params.password);

  try {
    const res = yield call(API.resetPassword, data);
    yield put(resetPasswordSuccessed(res));
    yield call(callback?.bind());
  } catch(error) {
    yield put(resetPasswordFailed(error.message));
  }
}

export function* watchWorkers() {
  yield takeLatest(SIGN_IN_WITH_EMAIL, signInWithEmail);
  yield takeLatest(FORGOT_PASSWORD, forgotPassword);
  yield takeLatest(RESET_PASSWORD, resetPassword);
}

export default function* rootSaga() {
  yield all([
    fork(watchWorkers)
  ]);
}